export const SORT_FILTERS_GAP = 16;
export const EXPAND_BUTTON_SIZE = 54; // calculated: arrow width:38 margin:16
export const TITLE_SORT_GAP = 32;
